import { render, staticRenderFns } from "./viewer.vue?vue&type=template&id=4813d4bd&"
import script from "./viewer.vue?vue&type=script&lang=js&"
export * from "./viewer.vue?vue&type=script&lang=js&"
import style0 from "./viewer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4813d4bd')) {
      api.createRecord('4813d4bd', component.options)
    } else {
      api.reload('4813d4bd', component.options)
    }
    module.hot.accept("./viewer.vue?vue&type=template&id=4813d4bd&", function () {
      api.rerender('4813d4bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/file-previewer/viewer.vue"
export default component.exports